import React from "react";

import {
  Driver,
  driverStatusToText,
  getWorkTimeMinutes,
} from "../../../../models";

import "./DailyDriversCard.scss";

export interface DailyDriversCardProps {
  drivers: Driver[];

  onViewDriver: (driverId: string) => () => void;
}

export function DailyDriversCard(props: DailyDriversCardProps) {
  const { drivers, onViewDriver } = props;

  const renderDriver = (driver: Driver): React.ReactNode => {
    return (
      <div
        className="driver-container"
        key={driver.id}
        onClick={onViewDriver(driver.id)}
      >
        <div className="name-container">
          <div className="name-text">{driver.name}</div>

          <div className="status-text">{driverStatusToText[driver.status]}</div>
        </div>

        <div className="work-time-text">
          {getWorkTimeMinutes(driver.onClock)}
        </div>
      </div>
    );
  };

  return (
    <div className="daily-drivers-card-component">
      <div className="header">
        <div className="header-title">Drivers</div>
      </div>

      {drivers.length > 0 ? (
        drivers.map(renderDriver)
      ) : (
        <div>No drivers worked today</div>
      )}
    </div>
  );
}
